package se.mittpass.web.components

import se.mittpass.web.*
import se.mittpass.web.components.*
import se.mittpass.web.pages.*
import se.mittpass.web.viewmodel.*
import se.mittpass.web.style.*


import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.I

@Composable
fun FaIcon(classes: String, size: String? = null, color: String? = null) {
    I({
        classes(*classes.split(" ").toTypedArray())
        style {
            size?.let { property("font-size", it) }
            color?.let { property("color", it) }
            property("line-height", "1")
        }
    })
}
